import type { TokenStore } from "@/domains/tokens/token-store"

import { priceToTick } from "./tick-calculations"

/**
 * Convert a price string to an aligned tick. Returns undefined on empty / invalid input.
 */
export function tryParseTickFromPrice(args: {
  price: string | undefined
  token0: TokenStore
  token1: TokenStore
  tickSpacing: number
  invert?: boolean
}): number | undefined {
  const { price } = args
  if (!price || price.trim() === "" || price === "-" || price === ".") {
    return undefined
  }

  const parsed = parseFloat(price)
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return undefined
  }

  try {
    return priceToTick({
      price,
      token0: args.token0,
      token1: args.token1,
      tickSpacing: args.tickSpacing,
      invert: args.invert,
    })
  } catch {
    return undefined
  }
}

export function roundToTickSpacing(tick: number, tickSpacing: number): number {
  return Math.round(tick / tickSpacing) * tickSpacing
}
